$('[data-personlist]').each(function () {
    const cards = $(this).find('[data-person]');
    const infoBox = $(this).find('.person__info');
    let infoWidth;

    if (window.innerWidth <= 768) {
        infoWidth = 1;
    };
    if (window.innerWidth > 720 && window.innerWidth < 960) {
        infoWidth = 1;
    };
    if (window.innerWidth > 960) {
        infoWidth = parseInt($(this).attr('data-desktop-count'));
    };

    $(cards).each(function (index) {
        let cardNum = index + 1;
        let rowNum = Math.ceil(cardNum / infoWidth);
        let bioEnd = infoWidth + 1;
        let currentIndex = index;

        if ($(this).attr('data-noclick') !== undefined) return;

        $(this).click(function () {
            const thisGroup = $(this).parent().find('[data-person]');

            if ($(this).hasClass('active') == true) {
                $(this).toggleClass('active');

                infoBox.addClass('d-none');

                $(thisGroup).each(function (index) {
                    $(this).removeClass('semitransparent');
                });
            } else {
                $(this).addClass('active');

                infoBox.removeClass('d-none');

                infoBox.attr('style', `grid-column: 1 / ${bioEnd}; grid-row: ${rowNum + 1}`);
                infoBox.html($(this).find('.person__about').html());

                $(thisGroup).each(function (index) {
                    $(this).toggleClass('semitransparent', index != currentIndex);
                    $(this).toggleClass('active', index == currentIndex);
                });
                $('html,body').animate({
                    scrollTop: $(this).offset().top - $('header').height()
                }, 500)
            }

        })
    })
})